import { ArrowDownToLine, CalendarDays, ChevronDown, Download } from "lucide-react";
import { useState } from "react";
import ExportSubscriptionsModal from "../../Subscriptions/components/modals/ExportSubscriptions";
import ExportModal from "../../Payments/components/modals/ExportModal";

export default function AnalyticsHeader() {
    const [isOpen, setIsOpen] = useState(false);
    const [openSubscriptions, setOpenSubscriptions] = useState(false);
    const [openPayments, setOpenPayments] = useState(false);
    return (
        <div className="w-full flex items-center justify-end gap-x-3">
            <div className="relative">
                <select className="w-40 h-8 px-3 py-1 rounded-md bg-card text-xs text-white">
                    <option value="All">All Services</option>
                    <option value="kanema">Kanema Online</option>
                    <option value="mingoli">Mingoli</option>
                    <option value="katswiri">Katswiri</option>
                    <option value="nkhani">Nkhani</option>
                </select>
            </div>

            <div className="relative">
                <select className="w-40 h-8 px-3 py-1 rounded-md bg-card text-xs text-white">
                    <option value="All">All Time</option>
                    <option value="6Months">6 Months</option>
                    <option value="1Month">1 Month</option>
                    <option value="1Week">1 Week</option>
                    <option value="Today">Today</option>
                </select>
            </div>

            <div className="relative">
                <div
                    onClick={() => setIsOpen(!isOpen)}
                    className="bg-card w-fit flex items-center gap-x-2 px-3 py-2 rounded-md cursor-pointer hover:scale-105"
                >
                    <ArrowDownToLine className="text-white w-4 h-4" />
                    <p className="text-white text-sm">Download Report</p>
                </div>

                {isOpen && (
                    <div className="absolute right-0 mt-2 w-40 bg-card border border-gray-700 rounded-md shadow-lg z-50">
                        <button
                            className="block w-full text-left px-4 py-2 text-sm text-white hover:bg-gray-700"
                            onClick={() => {
                                setIsOpen(false);
                                setOpenSubscriptions(true);
                            }}
                        >
                            Subscriptions
                        </button>
                        <button
                            className="block w-full text-left px-4 py-2 text-sm text-white hover:bg-gray-700"
                            onClick={() => {
                                setIsOpen(false);
                                setOpenPayments(true);
                            }}
                        >
                            Payments
                        </button>
                    </div>
                )}
            </div>

            <ExportSubscriptionsModal
                isOpen={openSubscriptions}
                onClose={() => setOpenSubscriptions(false)}
            />

            <ExportModal
                isOpen={openPayments}
                onClose={() => setOpenPayments(false)}
            />
        </div>
    );
}